<template>
  <div class="modal fade" id="keyDeepmodal" tabindex="-1" aria-labelledby="keyDeepmodal" data-bs-backdrop="static"
    aria-hidden="true">
    <div class="modal-dialog large-modal modal-dialog-centered">
      <div class="modal-content">
        <div class="modalLoaderpos" v-show="!KDDloader">
          <widgetLoadingComp></widgetLoadingComp>
        </div>
        <div class="modal-header">
          <h5 class="modal-title">
            Doubleclick - Top insights for <b v-show="nexVal">{{ nexVal }}-> </b> <b>{{ colVal }}</b>
            <span v-show="inscol.length > 0">(from field <i>'{{ inscol }}'</i>)</span>
          </h5>
          <div class="close-container myfaBtn" aria-label="Close" v-on:click="closeKDeepMod()">
            <div class="leftright"></div>
            <div class="rightleft"></div>
          </div>
        </div>
        <div class="modal-body modalChart modal-bodyHt KeydmdHt modalbodypanel" :style="$store.state.TClrs">
          <div v-show="divNo == 1">
            <div v-show="isDIns">
              <div class="container-fluid">
                <div class="row" v-show="!showSettings">
                  <div class="col-12 text-end">
                    <a class="effect btn-table thin eff-lg" @click="getShowTableData()" style="margin-right: 10px;">
                      View Data
                    </a>
                    <a class="effect btn-ai thin eff-lg" v-on:click="createViewDD()" v-show="isCreateView">
                      Analyze Further
                    </a>
                  </div>
                  <div class="col-12">
                    <div class="tabA">
                      <input type="checkbox" id="chck11" class="inputA" v-model="isadvSets">
                      <label class="tabA-label" for="chck11">Overall</label>
                      <div class="tabA-content">
                        <div class="row card-quality boxShadow spl cdmrgn">
                          <ul class="bulletList">
                            <li v-for="KDins in drill_Ins" :key="KDins" v-show="KDins != ''">
                              {{ KDins }}</li>
                          </ul>
                        </div>
                      </div>
                      <div v-show="kinsightError">
                        <insightErrMsg compTitle="Key Deep Overall" compId="chck12"></insightErrMsg>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mr10top" >
                    <div class="tabA">
                      <input type="checkbox" id="chck12" class="inputA" v-model="isadvSets1">
                      <label class="tabA-label" for="chck12">Drilldown</label>
                      <div class="tabA-content tabContflow" style="min-height: 120px">
                        <div class="row card-quality boxShadow spl cdmrgn">
                          <div class="myDDBtn myfaBtn settings" v-on:click="showSettingsFunc()"
                            data-balloon-length="large" aria-label="Click to add/remove Columns for Drilldown Insights"
                            data-balloon-pos="down-right" style="width: 40px !important; height: 40px !important;">
                            <img src="../assets/images/settings-gear.svg" class="darkSetSvg"
                              v-show="!isReadOnlyView && $store.state.TClrs != 'darkTheme'" alt="Settings Icon"
                              style="height: 26px;margin-left: -4px;">
                            <img src="../assets/images/settings-gearDark.svg" alt="Settings Icon"
                              v-show="!isReadOnlyView && $store.state.TClrs == 'darkTheme'"
                              style="height: 26px;margin-left: -4px;">
                          </div>
                          <ul class="bulletList" v-show="drill_Ins_dd.length > 0">
                            <li v-for="KDins in drill_Ins_dd" :key="KDins" v-show="KDins.ins_dd != ''">{{ KDins.ins_dd }}
                              <ul class="bulletList">
                                <li v-for="KDD_ins in KDins.KDins_dd" :key="KDD_ins" v-show="KDD_ins != ''">{{ KDD_ins }}
                                </li>
                              </ul>
                            </li>
                          </ul>
                          <div v-show="drill_Ins_dd.length == 0">
                            <p>Sorry! Something Not able to fetch information. change the filter value!</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mr10top">
                    <div class="tabA">
                      <input type="checkbox" id="chck13" class="inputA" v-model="isadvSets2">
                      <label class="tabA-label" for="chck13">Charts</label>
                      <div class="tabA-content">
                        <div class="row">
                          <div v-show="isShowTrend" class="col-12 col-lg-4 position-relative mb-2" id="keyDeepIncomResol">
                            <div class="cardR">
                              <div class="boxR">
                                <div class="explain-loader" v-show="isChartAPIError">
                                  <apiErrorComponent @tryReload="tryReload" compTitle="Incoming Vs Resolved Key Deep Q"
                                    compId="keyDeepIncomResol"></apiErrorComponent>
                                </div>
                                <div class="content-panel1 crt1 contpaddbx" id="crt1" v-show="!isChartAPIError">
                                  <div class="insideL  hide-on-presentation ">
                                    <div class="icon">
                                      <font-awesome-icon icon="fa-solid fa-bars" />
                                    </div>
                                    <div class="contents">
                                      <span v-show="!IswordErr">
                                        <font-awesome-icon icon="fa-solid fa-chalkboard-teacher"
                                          v-on:click="addToSlider('keyDeepIncomResol', 'Incoming Vs Resolved')"
                                          title="Add to Storyboard" />
                                        <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                                          v-on:click="downloadDom(1)" />
                                      </span>
                                    </div>
                                  </div>
                                  <div v-show="KDDchartload"></div>
                                  <div class="chartTitle hide-on-presentation key-deep-title themeclr2">
                                    Incoming Vs Resolved
                                  </div>
                                  <div class="explain-loader" v-show="!isLoadWordInco">
                                    <widgetLoadingComp></widgetLoadingComp>
                                  </div>
                                  <div class="chartHeightControlDD">
                                    <div id="IncResChartDD" style="width: 100%; margin: 0 auto;"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            :class="isShowTrend ? 'col-12 col-lg-4 position-relative mb-2' + screenWidth : 'col-12 col-lg-6 position-relative mb-2' + screenWidth"
                            v-show="ins_mttr != null && ins_mttr.length != 0" id="keyDeepMTTR">
                            <div class="cardR">
                              <div class="boxR">
                                <div class="content-panel1" v-show="isChartAPIError">
                                  <apiErrorComponent @tryReload="tryReload" compTitle="MTTR by
                                                                    Priority Key Deep Q" compId="keyDeepMTTR">
                                  </apiErrorComponent>
                                </div>
                                <div class="content-panel1 crt2 contpaddbx" id="crt2" v-show="!isChartAPIError">
                                  <div class="insideL  hide-on-presentation ">
                                    <div class="icon">
                                      <font-awesome-icon icon="fa-solid fa-bars" />
                                    </div>
                                    <div class="contents">
                                      <span v-show="!IswordErr">
                                        <font-awesome-icon icon="fa-solid fa-chalkboard-teacher"
                                          v-on:click="addToSlider('keyDeepMTTR', 'MTTR by Priority')"
                                          title="Add to Storyboard" />
                                        <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                                          v-on:click="downloadDom(2)" />
                                      </span>
                                    </div>
                                  </div>
                                  <div v-show="KDDchartload"></div>
                                  <div class="chartTitle hide-on-presentation key-deep-title themeclr2">MTTR by
                                    Priority
                                  </div>
                                  <div class="explain-loader" v-show="!isLoadWordMTTR">
                                    <widgetLoadingComp></widgetLoadingComp>
                                  </div>
                                  <ag-grid-vue style="width: 100%; height:380px;"
                                    class="table-striped thmHead myMttrTbl ag-theme-alpine" :columnDefs="mttrcolsDefs"
                                    @grid-ready="onReMttr" :enableBrowserTooltips="true">
                                  </ag-grid-vue>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            :class="isShowTrend ? 'col-12 col-lg-4 position-relative' : 'col-12 col-lg-6 position-relative'"
                            id="keyDeepWordcloud">
                            <div class="cardR">
                              <div class="boxR">
                                <div class="explain-loader" v-show="!isLoadWord">
                                  <widgetLoadingComp></widgetLoadingComp>
                                </div>
                                <div class="explain-loader" v-show="isChartAPIError">
                                  <apiErrorComponent @tryReload="tryReload" compTitle="Wordcloud Key Deep Q"
                                    compId="keyDeepWordcloud"></apiErrorComponent>
                                </div>
                                <div class="content-panel1 crt3 contpaddbx" id="crt3" v-show="!isChartAPIError">
                                  <div class="insideL  hide-on-presentation ">
                                    <div class="icon">
                                      <font-awesome-icon icon="fa-solid fa-bars" />
                                    </div>
                                    <div class="contents">
                                      <span v-show="!IswordErr">
                                        <font-awesome-icon icon="fa-solid fa-chalkboard-teacher"
                                          v-on:click="addToSlider('keyDeepWordcloud', 'Wordcloud')"
                                          title="Add to Storyboard" />
                                        <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                                          v-on:click="downloadDom(3)" />
                                      </span>
                                    </div>
                                  </div>
                                  <div v-show="KDDchartload"></div>
                                  <div class="chartTitle hide-on-presentation key-deep-title themeclr2">
                                    Wordcloud</div>
                                  <div class="panel-body text-center panelbodyHt">
                                    <div class="panelbodyMgn">
                                      <div class="row">
                                        <div class="col-10">
                                          <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="drop1"
                                            :options="WCFilteron" :multiple="false" :allow-empty="false"
                                            deselect-label="can't Deselect" selectLabel="" :close-on-select="true"
                                            @close="getWordCloud()" placeholder="Pick" track-by="name" label="name" />
                                        </div>
                                        <div class="col-2">
                                          <div class="icofont hide-on-presentation">
                                            <font-awesome-icon :icon="['fas', 'eye']" title="Show Blank Values"
                                              class="myfaBtn cursor-pointer mar10Rt" v-on:click="removeBlank()"
                                              v-show="isRemoveBlank" data-bs-toggle="tooltip" />
                                            <font-awesome-icon :icon="['fas', 'eye-slash']"
                                              class="myfaBtn cursor-pointer mar10Rt" v-on:click="removeBlank()"
                                              v-show="!isRemoveBlank" data-bs-toggle="tooltip"
                                              title="Click to see non-blank values only" />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="chartHeightControlDD keyDeepWordClo" v-show="!IswordErr && isWCshow">
                                      <div class="cursor-pointer" id="my_datavizDD" style="height: 330px;"> </div>
                                    </div>
                                    <div v-if="IswordErr"></div>
                                    <div v-if="IsWordData" class="widgetError text-center"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row" style="margin-top: 20px;">
                          <div v-show="isShowHourlyHM" class="col-12 position-relative"
                            :class="isShowDailyHM ? 'col-7' : 'col-12'" id="keyDeepHoverly">
                            <div class="cardR">
                              <div class="boxR">
                                <div class="content-panel1" v-show="isChartAPIError" style="height: auto;">
                                  <apiErrorComponent @tryReload="tryReload" compTitle="Hour of
                                                                    Week Heatmap Key Deep Q" compId="keyDeepHoverly">
                                  </apiErrorComponent>
                                </div>
                                <div class="content-panel1 crt4" id="crt4" v-show="!isChartAPIError">
                                  <div class="insideL  hide-on-presentation ">
                                    <div class="icon">
                                      <font-awesome-icon icon="fa-solid fa-bars" />
                                    </div>
                                    <div class="contents">
                                      <span>
                                        <font-awesome-icon icon="fa-solid fa-chalkboard-teacher"
                                          v-on:click="addToSlider('keyDeepHoverly', 'Hour of Week Heatmap')"
                                          title="Add to Storyboard" />
                                        <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                                          v-on:click="downloadDom(4)" />
                                      </span>
                                    </div>
                                  </div>
                                  <div v-if="!KDDchartloadHH">
                                    <widgetLoadingComp></widgetLoadingComp>
                                  </div>
                                  <div class="chartTitle hide-on-presentation key-deep-title themeclr2">Hour of
                                    Week Heatmap
                                  </div>
                                  <div class="chartHeightControlDDH" style="padding:16px 8px">
                                    <div id="hourlydd_dataviz"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row" style="margin-top: 20px;">
                          <div v-show="isShowDailyHM" class="col-12 position-relative"
                            :class="isShowHourlyHM ? 'col-5' : 'col-12'" id="keyDeepMonthHEatmap">
                            <div class="cardR">
                              <div class="boxR">
                                <div class="content-panel1" v-show="isChartAPIError" style="height: auto;">
                                  <apiErrorComponent @tryReload="tryReload" compTitle="Day of
                                                                    Month Heatmap Key Deep Q"
                                    compId="keyDeepMonthHEatmap">
                                  </apiErrorComponent>
                                </div>
                                <div style="margin-top: 5px; padding-bottom: 20px;padding-top: 8px;"
                                  class="content-panel1 crt5" id="crt5" v-show="!isChartAPIError">
                                  <div class="insideL  hide-on-presentation ">
                                    <div class="icon">
                                      <font-awesome-icon icon="fa-solid fa-bars" />
                                    </div>
                                    <div class="contents">
                                      <span v-show="!IswordErr">
                                        <font-awesome-icon icon="fa-solid fa-chalkboard-teacher"
                                          v-on:click="addToSlider('keyDeepMonthHEatmap', 'Day of Month Heatmap')"
                                          title="Add to Storyboard" />
                                        <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                                          v-on:click="downloadDom(5)" />
                                      </span>
                                    </div>
                                  </div>
                                  <div class="explain-loader" v-show="!KDDchartloadDH">
                                    <widgetLoadingComp></widgetLoadingComp>
                                  </div>
                                  <div class="chartTitle hide-on-presentation key-deep-title themeclr2">Day of
                                    Month Heatmap</div>
                                  <div class="panel-body text-center chartHeightControl" style="margin-top: 30px;">
                                    <div id="heatmapDD" style="height: 320px;"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-show="showSettings">
                  <div class="row card-quality myBoxShadow spl" sv-root="insId">
                    <div class="col-sm-12">
                      <h4><label>Configure Column for Insights <small>(For Doubleclick)</small> :
                        </label></h4>
                    </div>
                    <div class="col-sm-5">
                      <div class="panel panel-default h-100">
                        <div class="panel-heading">
                          <h5 class="panel-title addOpacity text-center">
                            Choosen Columns
                          </h5>
                        </div>
                        <div class="panel-body nopadding">
                          <draggable class="list-group drag-list apps-container addOpacity" :list="getgudLisC"
                            group="configGroup" itemKey="name" :move="checkMove">
                            <template #item="{ element }">
                              <div class="list-group-item app"><i class="fa fa-arrows-alt" aria-hidden="true"></i> {{
                                element }}</div>
                            </template>
                          </draggable>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <h3 class="text-center"><i class="fas fa-arrows-alt-h"></i></h3>
                    </div>
                    <div class="col-sm-5">
                      <div class="panel panel-default h-100">
                        <div class="panel-heading">
                          <h5 class="panel-title addOpacity text-center">
                            Unchoosen Columns
                          </h5>
                        </div>
                        <div class="panel-body nopadding">
                          <draggable class="list-group drag-list apps-container addOpacity" :list="getnongudLisC"
                            group="configGroup" itemKey="name" :move="checkMove">
                            <template #item="{ element }">
                              <div class="list-group-item app"><i class="fa fa-arrows-alt" aria-hidden="true"></i> {{
                                element }}</div>
                            </template>
                          </draggable>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 text-end" style="margin-top: 20px;padding-top: 5px;">
                      <div class="effect btn-save eff-md mt-0" v-on:click="saveColumnInsight()"
                        style="margin-right: 20px;">
                        Save
                      </div>
                      <button class="btn stdBtn btn-bordered" v-on:click="hideSettingsFunc()"
                        style="float: right;">Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="noDataWgt">
              <apiErrorComponent @tryReload="tryReload" compTitle="" compId="keyDeepMTTR"></apiErrorComponent>
            </div>
          </div>
          <div v-if="divNo == 2">
            <div class="container-fluid">
              <div class="row card-quality myBoxShadow" style="padding: 20px 10px;">
                <div class="col-12 text-end">
                  <a class="effect btn-back thin eff-md" v-on:click="backTo()">
                    Go Back
                  </a>
                </div>
                <div class="col-lg-2 col-sm-4">
                  <label for="startdt">
                    Start Date :
                  </label>
                  <div class="input-group datinpwd">
                    <Datepicker :dark="$store.state.TClrs != 'lightTheme'" v-model="startdt" :enableTimePicker="false" />
                  </div>
                </div>
                <div class="col-lg-2 col-sm-4">
                  <label for="enddt">
                    End Date :
                  </label>
                  <div class="input-group datinpwd">
                    <Datepicker :dark="$store.state.TClrs != 'lightTheme'" v-model="enddt" :enableTimePicker="false" />
                  </div>
                </div>
                <div class="col-lg-2 col-sm-4">
                  <label for="enddt">
                    Time Zone :
                  </label>
                  <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="timeZone" :options="timeZoneArr"
                    track-by="value" label="value" selectLabel="" :custom-label="customLabel" :show-labels="false"
                    :multiple="false" :close-on-select="true" />
                </div>
                <div class="col-lg-3 col-sm-6">
                  <label for="startdt">
                    Analyse On :
                  </label>
                  <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="AnalysisOp" :options="AnalysisOns"
                    :multiple="false" :allow-empty="false" selectLabel="" deselect-label="can't Deselect"
                    :close-on-select="true" placeholder="Pick" track-by="name" label="name" />
                </div>
                <div class="col-lg-3 col-sm-6">
                  <label>Second Level Analysis : </label>
                  <!-- <span class="rtfloat">
                                    <font-awesome-icon :icon="['fas', 'fa-th-list']"
                                        uib-tooltip="Click to see the Field's Profile" v-on:click="opnportPop(0)"
                                        class="myfaBtn cursor-pointer" />
                                </span> -->
                  <VueMultiselect class="mymultiselect  hide-on-presentation  input-group myMarginTop" openDirection="bottom"
                    v-model="ins_priorLv2op" :options="AnalysisOns" :multiple="false" selectLabel="" :allow-empty="false"
                    deselect-label="can't Deselect" :close-on-select="true" placeholder="Pick" track-by="name"
                    label="name" />
                </div>
              </div>
              <div class="row card-quality myBoxShadow" style="padding: 20px 10px;">
                <div class="col-12">
                  <h4><label>Filters : </label></h4>
                </div>
                <div class="col-4" v-show="portlevels.length == 0">
                  <h6 class="fltpadd">Add Filters </h6>
                </div>
                <div class="col-8" v-show="portlevels.length == 0">
                  <button type="button" class="btn calendarBtn themeclr" v-on:click="modifyPortLvl(index, 2);">
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
                <div class="col-12">
                  <div class="row mr10px" v-for="(addfilters, index) in portlevels" :key="addfilters">
                    <div class="col-2">
                      <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="addfilters.filter_key"
                        :options="AnalysisOns" :multiple="false" :allow-empty="false" deselect-label="can't Deselect"
                        :close-on-select="true" selectLabel="" @close="loadPortVals(addfilters.filter_key, index);"
                        placeholder="Pick" track-by="name" label="name" />
                    </div>
                    <div class="col-7">
                      <VueMultiselect class="mymultiselect  hide-on-presentation  form-control selectPriority" openDirection="bottom"
                        v-model="addfilters.filter_vals" :options="addfilters.filter_ops" :multiple="true" selectLabel=""
                        :close-on-select="false" placeholder="Pick" track-by="val" label="val" />
                    </div>
                    <div class="col-2 text-end">
                      <div class="btn-group" role="group" aria-label="...">
                        <button type="button" class="btn minusBtn" v-on:click="modifyPortLvl(index, 1);">
                          <font-awesome-icon :icon="['fas', 'fa-minus']"></font-awesome-icon>
                        </button>
                        <button type="button" class="btn addBtn mar10lft"
                          :disabled="!(index == portlevels.length - 1) || index > 4" v-on:click="modifyPortLvl(index, 0);"
                          style="margin-left: 10px;">
                          <font-awesome-icon :icon="['fas', 'fa-plus']"></font-awesome-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="divNo == 3">
            <div class="container-fluid">
              <div class="row" style="padding: 20px 10px;">
                <div class="col-12 text-end">
                  <a class="effect btn-back thin eff-md" v-on:click="backTo()">
                    Go Back
                  </a>
                </div>
                <div class="col-12" style="padding:15px 30px">
                  <div v-on:click="downloadTickets()" class="myfaBtn spl" v-show="showDownbtn">
                    <font-awesome-icon :icon="['fas', 'fa-download']" />
                  </div>
                  <div id="myGrid" style="height: 500px; width:100%;"
                    class="table-striped thmHead v01 ag-theme-balham myHomeTable">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer" :style="$store.state.TClrs" v-if="divNo == 2">
          <div class="effect btn-analyze eff-lg" v-on:click="goAnalyze()">Analyze</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  useRoute
} from 'vue-router';
import {
  Modal
} from 'bootstrap';
import 'echarts-wordcloud';
import * as echarts from 'echarts';
import {
  AgGridVue
} from 'ag-grid-vue3';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import domtoimage from "dom-to-image-more";
import draggable from 'vuedraggable'
import dataTempT from '../data/timezones.json'
import screenShotMix from "./../mixin/screenShotMix"
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import widgetLoadingComp from './smallcomp/widgetloader.vue';
import * as agGrid from "ag-grid-community";
import "ag-grid-community/styles/ag-theme-balham.css";
import apiErrorComponent from './smallcomp/apierror.vue';
import insightErrMsg from './smallcomp/insErrMsg.vue';
var insightInfo = {}
var sendIns;
var myWCChart;
const columnDefs = [];
let chartDomWC, hourlydd_dataviz, heatmapDD, chartDomIvC, heatmapDDVar, hourlydd_datavizmyChart, myChartIvC;
export default {
  name: 'KeyDeep',
  mixins: [screenShotMix],
  props: {
    getKeyInfoC: Object,
    getPins: Object,
    getpass: Object,
    getcolumnpriorToChild: Object,
  },
  components: {
    Datepicker,
    AgGridVue,
    draggable,
    widgetLoadingComp,
    apiErrorComponent,
    insightErrMsg
  },
  data() {
    return {
      modal: undefined,
      isDIns: false,
      isadvSets: true,
      isadvSets1: false,
      isRemoveBlank: false,
      isadvSets2: true,
      drill_Ins: "",
      drill_Ins_dd: [],
      isShowHourlyHM: true,
      isShowDailyHM: true,
      isCreateView: false,
      colVal: "",
      nexVal: "",
      inscol: "",
      KDDloader: false,
      KDDchartload: false,
      drop1: {},
      WCFilteron: this.getpass.WCFilteron,
      mttrApi: null,
      ins_mttr: [],
      AnalysisOns: [],
      portlevels: [],
      isShowTrend: true,
      mttrcolsDefs: [],
      timeZoneArr: dataTempT,
      IswordErr: false,
      IsWordData: false,
      divNo: 1,
      startdt: "",
      enddt: "",
      timeZone: "",
      AnalysisOp: null,
      ins_priorLv2op: "",
      showSettings: false,
      isReadOnlyView: false,
      getgudLisC: this.getcolumnpriorToChild.gud_filt,
      getnongudLisC: this.getcolumnpriorToChild.non_gud_filt,
      showEdited: false,
      getKeyInfo: this.getKeyInfoC,
      screenWidth: "",
      myWordCTitle: "",
      wordchart: [],
      wordchartBlank: [],
      KDDchartloadHH: false,
      KDDchartloadDH: false,
      isAnimated: true,
      isAnimatedDay: true,
      isWCshow: true,
      tooltipPos: "display:none",
      isLoadWordInco: false,
      isLoadWordMTTR: false,
      isLoadWord: false,
      wcFilterOp: "",
      isTableLoad: false,
      showTableData: [],
      tableHeader: [],
      kinsightError: false,
      gridOptions: {
        defaultColDef: {
          sortable: true,
          filter: 'agTextColumnFilter',
          resizable: true,
        },
        enableSorting: true,
        enableBrowserTooltips: true,
        enableFilter: true,
        pagination: true,
        paginationPageSize: 10,
        rowData: null,
        columnDefs: columnDefs,
      },
      isChartAPIError: false,
      showDownbtn: false,
      noDataWgt: false,
    }
  },
  methods: {
    resizeReload() {
      if (hourlydd_datavizmyChart != undefined) {
        hourlydd_datavizmyChart.resize()
      }
      if (heatmapDDVar != undefined) {
        heatmapDDVar.resize()
      }
      if (myWCChart != undefined) {
        myWCChart.resize()
      }
      if (myChartIvC != undefined) {
        chartDomIvC.style.width = (document.getElementById('keyDeepIncomResol').clientWidth - 100) + "px";
        myChartIvC.resize()
      }
    },
    tryReload() {
      this.getDrillWgts(sendIns, this.getKeyInfo.kDrillcond)
    },
    getShowTableData() {
      this.divNo = 3;
      this.showDownbtn = false;
      setTimeout(() => {
        const eGridDiv = document.querySelector('#myGrid');
        new agGrid.Grid(eGridDiv, this.gridOptions);
        this.axios.post(this.uriApiUrl + 'DataAnalysis/deep_kinsight?Cond=1&asg_id=' + this.asgId,
          sendIns,{
      headers: {
            'Content-Type': 'application/json'
          }})
          .then((response) => {
            if (response.status == 200) {
              if (response.data != "Nodata" && response.data != "Error" && response
                .data != [
                  "Error"
                ]) {
                this.dynamicallyConfigureColumnsFromObject(response.data[0])
                this.gridOptions.api.setRowData(response.data);
              }
            }
          }).catch((response) => {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in Top Insights Drilldown. Try after sometime!'
            })
          })
      }, 100);
    },
    dynamicallyConfigureColumnsFromObject(anObject) {
      const colDefs = this.gridOptions.api.getColumnDefs();
      colDefs.length = 0;
      const keys = Object.keys(anObject)
      keys.forEach(key => colDefs.push({
        field: key,
        tooltipField: key
      }));
      this.gridOptions.api.setColumnDefs(colDefs);
      this.showDownbtn = true;
    },
    downloadTickets() {
      this.gridOptions.api.exportDataAsCsv({
        fileName: "Drilldown_data.csv"
      });
    },
    swapChartsWorldCloud() {
      this.isWCshow = !this.isWCshow;
      setTimeout(() => {
        if (this.isWCshow) {
          this.drawCloudDD(0);
        } else {
          this.drawChart();
        }
      }, 500);
    },
    swapChartsDay() {
      this.isAnimatedDay = !this.isAnimatedDay;
      this.drawDailyTrend()
    },
    swapCharts() {
      this.isAnimated = !this.isAnimated;
      this.drawHourlyTrend();
    },
    addToSlider(idPara, title) {
      let insArr = [];
      let name = title;
      if (idPara == 'keyDeepMTTR') {
        this.screenWidth = 'col-6'
      }
      let screenShort = {
        id: idPara,
        name: idPara + '.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
      setTimeout(() => {
        this.screenWidth = ''
      }, 5000);
    },
    percGetter(params) {
      return params.data.slaadherence + '%'
    },
    customLabel({
      value,
      abbr
    }) {
      return `${value}(${abbr})`
    },
    daysGetter(params) {
      if (params.data != undefined) {
        var pier = params.data.Mttr
        pier = Math.round(pier);
        var hours = Math.floor(pier / 60);
        var minutes = pier % 60;
        var timeret = "";
        if (hours > 0) {
          if (hours < 24) {
            timeret += hours + "h ";
          } else {
            var days = Math.floor(hours / 24);
            hours = hours - (days * 24);
            timeret += days + "d " + hours + "h ";
          }
        }
        if (minutes > 0) {
          timeret += minutes + "m ";
        }
        if (timeret == "") {
          timeret = "< 1min"
        }
        return timeret
      } else {
        return ''
      }
    },
    goAnalyze() {
      this.$parent.enddt = this.enddt;
      this.$parent.startdt = this.startdt
      this.$parent.timeZone = this.timeZone
      this.$parent.AnalysisOp = this.AnalysisOp
      this.$parent.ins_priorLv2op = this.ins_priorLv2op
      this.$parent.portlevels = this.portlevels
      this.$parent.getAnalyse(1);
      this.divNo = 1;
      this.modal.hide()
    },
    backTo() {
      this.divNo = 1;
    },
    showSettingsFunc() {
      this.showSettings = true;
    },
    hideSettingsFunc() {
      this.showSettings = false;
    },
    checkMove() {
      this.showEdited = true
    },
    saveColumnInsight() {
      if (this.getcolumnpriorToChild != undefined & this.getcolumnpriorToChild.length != 0) {
        var col_filter = {
          "gud_filt": this.getgudLisC,
          "non_gud_filt": this.getnongudLisC
        }
        this.savecol = {
          "savcol": col_filter,
          "selid": this.getcolumnpriorToChild.selectedId,
          "edited": this.showEdited
        };
        this.axios.post(this.uriApiUrl + "DataAnalysis/savecolfiltval?asg_id=" + this.asgId, this.savecol,{
      headers: {
            'Content-Type': 'application/json'
          }})
          .then((response) => {
            this.insightloads = true;
            if (response.data != "Error") {
              this.$notify({
                type: "success",
                text: "Settings Saved Successfully"
              })
              this.getDrillInsights(sendIns, this.getKeyInfo.kDrillcond);
              this.hideSettingsFunc();
            } else {
              this.$notify({
                type: "error",
                text: "Sorry! Something went Wrong! Please try again after few minutes"
              })
            }
          }).catch(function (response) {
          });
      }
    },
    drawCloudDD() {
      let emit = this.$emit
      let thisHldr = this
      let wordArr = [];
      if (typeof this.drop1 == "string") {
        this.drop1 = this.WCFilteron.find(element => element.dbname == this.drop1)
      }
      if(document.getElementById('my_datavizDD') == null) return
      document.getElementById('my_datavizDD').innerHtml = "";
      if (this.isRemoveBlank) {
        for (let index = 0; index < this.wordchart.length; index++) {
          const element = this.wordchart[index];
          wordArr.push({
            name: element.Percentage > 1 ? element.text.slice(0, 18) : element.text,
            nameNew: element.text,
            value: element.weight,
            perc: element.Percentage
          })
        }
      } else {
        for (let index = 0; index < this.wordchartBlank.length; index++) {
          const element = this.wordchartBlank[index];
          wordArr.push({
            name: element.Percentage > 1 ? element.text.slice(0, 18) : element.text,
            nameNew: element.text,
            value: element.weight,
            perc: element.Percentage
          })
        }
      }
      chartDomWC = document.getElementById('my_datavizDD');
      if(chartDomWC == null) return;
      chartDomWC.style.height = "345px";
      myWCChart = echarts.init(chartDomWC, {
        renderer: 'svg',
        useDirtyRect: false
      });
      var option = {
        visualMap: {
          type: 'continuous',
          top: 0,
          calculable: false,
          text: ['High', 'Low'],
          inRange: {
            color: this.$store.state.chartColor
          },
          min: 0,
          max: wordArr[0].value,
          textStyle: {
            color: '#777',
            fontSize: 10
          },
        },
        grid: {
          top: '0',
          left: 10,
          right: 0,
          bottom: 0,
        },
        xAxis: {
          show: false,
          data: null,
        },
        yAxis: {
          show: false,
          data: null,
        },
        tooltip: {
          formatter: (params) => {
            return params.marker + params.data.nameNew + ": " + params.data.value + "(" + params
              .data.perc + "%)";
          },
          confine: true
        },
        series: [{
          animationDurationUpdate: 1000,
          universalTransition: true,
          type: 'wordCloud',
          sizeRange: [8, 28],
          rotationRange: [0, 0],
          gridSize: 1,
          shape: 'circle',
          width: '80%',
          height: '100%',
          layoutAnimation: true,
          keepAspect: false,
          drawOutOfBound: true,
          shrinkToFit: false,
          itemStyle: {
            borderRadius: 5,
            borderWidth: 2,
            opacity: 0.8,
            borderType: 'solid',
            borderColorSaturation: 0.7
          },
          emphasis: {
            itemStyle: {
              opacity: 1,
            },
          },
          data: wordArr
        }]
      };
      myWCChart.setOption(option);
      myWCChart.on('click', function (params) {
        if (params.componentType === 'series') {
          let clickitem = {
            "currpass": params.name,
            "filterop": params.dbname
          }
          emit("getKDrill", clickitem)
        }
      });
      setTimeout(() => {
        this.isLoadWord = true;
      }, 2000);
      this.isWCshow = true;
    },
    getWordCloud() {
      this.isLoadWord = false;
      this.IswordErr = false;
      this.IsWordData = false;
      this.isWCshow = true;
      this.IswcInsErr = false;
      this.wordCloudNumber = 0;
      this.wordinsight = [];
      this.sendIns = {
        "colval": this.drop1.dbname,
        "selid": this.selectedId,
        "edited": this.showEdited
      };
      sendIns.newCol = this.drop1.dbname;
      this.axios.post(this.uriApiUrl + "DataAnalysis/deep_kwgts?Cond=0&asg_id=" + this.asgId,
        sendIns,{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.data != "Error" && response.data != "Nodata") {
            this.wordwholedata = response.data;
            this.wordchart = this.wordwholedata.getWC.word_json;
            this.wordchartBlank = this.wordwholedata.getWC.word_json.slice(0)
            for (let i = 0; i < this.wordchartBlank.length; i++) {
              if (this.wordchartBlank[i].text == "(Blanks)") {
                this.wordchartBlank.splice(i, 1)
                i--
              }
            }
            this.isWCshow = false;
            setTimeout(() => {
              this.drawCloudDD()
            }, 5)
          } else if (response.data == "Nodata") {
            this.IsWordData = true;
            this.isWCshow = true;
            this.wordinsight = [];
          } else {
            this.IswordErr = true;
            this.isWCshow = true;
            this.wordinsight = [];
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in Word Cloud. Try after sometime!'
            })
          }
          this.insightloads = false
          this.isLoadWord = true;
        }).catch((error) => {
          this.IswordErr = true;
          this.isWCshow = true;
          this.wordinsight = [];
          this.isLoadWord = true;
          this.$notify({
            type: "error",
            text: 'Sorry! Something went wrong in Word Cloud. Try after sometime!'
          })
        })
    },
    removeBlank() {
      this.isRemoveBlank = !this.isRemoveBlank;
      setTimeout(() => {
        this.drawCloudDD()
      }, 5)
    },
    drawHourlyTrend() {
      let hourlysets = this.hourlywholedata.weekdata
      var emit = this.$emit
      var days
      var times
      this.KDDchartloadHH = false
      if (this.hourlywholedata.we_config == "wefs") {
        days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
      } else {
        days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
      }
      times = ["12am", "1am", "2am", "3am", "4am", "5am", "6am", "7am", "8am", "9am", "10am", "11am", "12pm",
        "1pm", "2pm", "3pm", "4pm", "5pm", "6pm", "7pm", "8pm", "9pm", "10pm", "11pm"
      ];
      hourlydd_dataviz = document.getElementById('hourlydd_dataviz');
      if(hourlydd_dataviz == null) return;
      hourlydd_dataviz.style.height = "370px"
      hourlydd_datavizmyChart = echarts.init(hourlydd_dataviz);
      let option;
      let data = [];
      let maxValue = 0;
      for (let index = 0; index < hourlysets.length; index++) {
        const element = hourlysets[index];
        data.push([element.day - 1, element.hour - 1, element.value, element.perc])
        if (element.perc > maxValue) {
          maxValue = element.perc;
        }
      }
      var isScatterEffectHDD = true
      option = {
        tooltip: {
          position: 'top',
          confine: true,
          formatter: (params) => {
            return "#Tickets for " + days[params.value[1]] + " at " + times[params.value[
              0]] + " is " + params.value[2] + "(" + params.value[3] + "%)";
          },
        },
        grid: {
          width: '88%',
          height: '75%',
          top: 50,
          bottom: 40,
          left: 120,
          right: 20
        },
        toolbox: {
          show: true,
          top: 0,
          right: 0,
          feature: {
            myTool1: {
              itemSize: 20,
              iconStyle: {
                borderColor: '#777'
              },
              show: true,
              title: 'Toggle Animation',
              icon: 'path://M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z',
              onclick: function () {
                isScatterEffectHDD = !isScatterEffectHDD
                hourlydd_datavizmyChart.setOption({
                  series: [{
                    name: '# Tickets',
                    type: isScatterEffectHDD ? 'effectScatter' :
                      'heatmap',
                    symbolSize: function (val) {
                      let sizeVal = val[3] / maxValue * 20
                      return sizeVal < 8 ? 8 : sizeVal;
                    },
                    symbol: 'roundRect',
                    data: data.map(function (item) {
                      return [item[1], item[0], item[2], item[
                        3] ||
                        '-'
                      ];
                    }),
                    label: {
                      show: isScatterEffectHDD ? false : true
                    },
                    emphasis: {
                      itemStyle: {
                        shadowBlur: 10,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                    }
                  }]
                })
              }
            },
          },
        },
        xAxis: {
          type: 'category',
          triggerEvent: true,
          data: times,
          axisLabel: {
            color: "#777",
            interval: 0,
            rotate: 0
          },
          splitArea: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              // Dark and light colors will be used in turns
              color: '#777aaa77'
            }
          },
          axisLine: {
            show: true, // Hide full Line
          },
        },
        yAxis: {
          type: 'category',
          triggerEvent: true,
          data: days,
          axisLabel: {
            color: "#777",
          },
          splitLine: {
            show: true,
            lineStyle: {
              // Dark and light colors will be used in turns
              color: '#777aaa77'
            }
          },
          splitArea: {
            show: false
          },
          axisLine: {
            show: false, // Hide full Line
          },
        },
        visualMap: {
          min: 0,
          top: 0,
          max: maxValue,
          inRange: {
            color: this.$store.state.chartColor,
          },
          text: ['High', 'Low'],
          calculable: true,
          orient: 'vertical',
          left: 'left',
          textStyle: {
            color: '#777',
            fontSize: 10
          },
        },
        series: [{
          name: '# Tickets',
          type: this.isAnimated ? 'effectScatter' : 'heatmap',
          symbolSize: function (val) {
            let sizeVal = val[3] / maxValue * 20
            return sizeVal < 8 ? 8 : sizeVal;
          },
          symbol: 'roundRect',
          data: data.map(function (item) {
            return [item[1], item[0], item[2], item[3] || '-'];
          }),
          itemStyle: {
            background: 'transparent',
          },
          label: {
            show: true
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      option && hourlydd_datavizmyChart.setOption(option);
      this.KDDchartloadHH = true
    },
    drawDailyTrend() {
      var emit = this.$emit
      var MonthRange
      let data = []
      let maxVal = 0;
      this.KDDchartloadDH = false;
      heatmapDD = document.getElementById('heatmapDD');
      if(heatmapDD == null) return;
      this.dailywholedata.years = []
      let startYr = parseInt(new Date(this.dailywholedata.heatmapday[0].date * 1000).toISOString().substring(
        0, 4))
      let endYr = parseInt(new Date(this.dailywholedata.heatmapday[this.dailywholedata.heatmapday.length - 1]
        .date * 1000).toISOString().substring(0, 4))
      for (let index = startYr; index <= endYr; index++) {
        this.dailywholedata.years.push(index.toString())
      }
      heatmapDD.style.height = this.dailywholedata.years.length * 260 + "px"
      document.getElementById('crt5').style.height = (parseInt(this.dailywholedata.years.length * 260) +
        130) + "px"
      let calendarArr = [];
      let seriesArr = []
      let dataArr = []
      let currYr = startYr
      for (let index = 0; index < this.dailywholedata.heatmapday.length; index++) {
        const element = this.dailywholedata.heatmapday[index];
        if (parseInt(new Date(element.date * 1000).toISOString().substring(0, 4)) != currYr) {
          dataArr.push(data)
          data = []
          currYr = parseInt(new Date(element.date * 1000).toISOString().substring(0, 4))
          data.push([new Date(element.date * 1000).toISOString().slice(0, 10), element.value, element
            .perc
          ]);
        } else {
          data.push([new Date(element.date * 1000).toISOString().slice(0, 10), element.value, element
            .perc
          ]);
        }
        if (maxVal < element.perc) {
          maxVal = element.perc;
        }
      }
      dataArr.push(data)
      for (let index = 0; index < this.dailywholedata.years.length; index++) {
        const element = this.dailywholedata.years[index];
        calendarArr.push({
          top: 250 * index + 70,
          cellSize: ['auto', 25],
          monthLabel: {
            color: '#777'
          },
          dayLabel: {
            color: '#777'
          },
          splitLine: {
            lineStyle: {
              color: "#777",
              width: 2
            }
          },
          range: element,
          itemStyle: {
            color: 'transparent',
            borderWidth: 0.5
          }
        })
        seriesArr.push({
          type: this.isAnimatedDay ? 'effectScatter' : 'heatmap',
          symbolSize: function (val) {
            let sizeVal = val[2] / maxVal * 10;
            return sizeVal < 5 ? 5 : sizeVal;
          },
          symbol: 'roundRect',
          coordinateSystem: 'calendar',
          data: dataArr[index],
          calendarIndex: index
        })
      }
      var isScatterEffectD = true;
      heatmapDDVar = echarts.init(heatmapDD);
      let option = {
        darkMode: true,
        background: 'transparent',
        tooltip: {
          confine: true,
          formatter: (params) => {
            let monArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep",
              "Oct", "Nov", "Dec"
            ]
            let dtArr = params.data[0].split("-");
            let dtStr = dtArr[2] + " " + monArr[parseInt(dtArr[1]) - 1] + " " + dtArr[0]
            return "#Tickets for " + dtStr + " is " + params.data[1] + "(" + params
              .data[2] + "%)";
          },
        },
        toolbox: {
          itemSize: 20,
          iconStyle: {
            borderColor: '#777'
          },
          feature: {
            myTool1: {
              show: true,
              title: 'Toggle Animation',
              icon: 'path://M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z',
              onclick: function () {
                isScatterEffectD = !isScatterEffectD
                for (let index = 0; index < seriesArr.length; index++) {
                  const element = seriesArr[index];
                  element.type = isScatterEffectD ? 'effectScatter' : 'heatmap';
                }
                heatmapDDVar.setOption({
                  series: seriesArr
                })
              }
            },
          },
        },
        visualMap: {
          min: 0,
          calculable: true,
          max: maxVal,
          inRange: {
            color: this.$store.state.chartColor,
          },
          orient: 'horizontal',
          left: 'center',
          top: 0,
          textStyle: {
            color: '#777',
            fontSize: 10
          },
        },
        calendar: calendarArr,
        series: seriesArr
      };
      option && heatmapDDVar.setOption(option);
      this.KDDchartloadDH = true
    },
    createViewDD() {
      this.divNo = 2;
      this.enddt = this.$parent.enddt;
      this.startdt = this.$parent.startdt
      this.timeZone = this.$parent.timeZone
      this.AnalysisOp = this.$parent.AnalysisOp
      this.ins_priorLv2op = this.$parent.ins_priorLv2op
      insightInfo = this.$parent.portlevels;
      this.portlevels = JSON.parse(JSON.stringify(insightInfo.slice(0)));
      var arrFilterKey = sendIns.get_wc_col.split('~')
      var arrFilterVals = sendIns.getKdrill.split('~')
      var arrFilterOps = []
      this.axios.post(this.uriApiUrl + 'DataAnalysis/getportfilter?asg_id=' + this.asgId, {
        filtername: arrFilterKey[0]
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error") {
              arrFilterOps.push(response.data)
              if (arrFilterKey.length > 1) {
                this.axios.post(this.uriApiUrl + 'DataAnalysis/getportfilter?asg_id=' + this
                  .asgId, {
                  filtername: arrFilterKey[1]
                },{
      headers: {
            'Content-Type': 'application/json'
          }})
                  .then((response) => {
                    if (response.status == 200) {
                      if (response.data != "Error") {
                        arrFilterOps.push(response.data)
                        for (let index = 0; index < arrFilterVals.length; index++) {
                          let pushdispvals = this.AnalysisOns.find(x => x.dbname
                            .toLowerCase() === arrFilterKey[index]
                              .toLowerCase());
                          if (pushdispvals != undefined) {
                            this.portlevels.push({
                              filterDisp: pushdispvals.name,
                              filter_key: pushdispvals,
                              filter_ops: arrFilterOps[index],
                              filter_vals: [{
                                val: arrFilterVals[index]
                              }]
                            });
                          }
                        }
                        this.isInsightloaded = true
                      } else {
                        this.$notify({
                          type: "error",
                          text: 'Sorry! Something went Wrong! Please try again after few minutes'
                        })
                      }
                    }
                    this.isInsightloaded = true
                  }).catch((error) => {
                    this.isInsightloaded = true
                    this.$notify({
                      type: "error",
                      text: "Sorry! Something went Wrong! Please try again after few minutes"
                    })
                  })
              } else {
                for (let index = 0; index < arrFilterVals.length; index++) {
                  let pushdispvals = this.AnalysisOns.find(x => x.dbname.toLowerCase() ===
                    arrFilterKey[index].toLowerCase());
                  if (pushdispvals != undefined) {
                    this.$parent.showEdited = true;
                    this.portlevels.push({
                      filterDisp: pushdispvals.name,
                      filter_key: pushdispvals,
                      filter_ops: arrFilterOps[index],
                      filter_vals: [{
                        val: arrFilterVals[index]
                      }]
                    });
                  }
                }
                this.isInsightloaded = true
              }
            } else {
              this.$notify({
                type: "error",
                text: 'Sorry! Something went Wrong! Please try again after few minutes'
              })
              this.isInsightloaded = true
            }
          }
        })
        .catch((error) => {
          this.isInsightloaded = true
          this.$notify({
            type: "error",
            text: "Sorry! Something went Wrong! Please try again after few minutes"
          })
        })
    },
    modifyPortLvl(index, val) {
      if (val == 0) {
        if (this.portlevels.length < 4) {
          this.portlevels.push({
            filter_key: null,
            filter_vals: [],
            filter_ops: []
          })
        } else {
          this.$notify({
            type: "warning",
            text: 'You cannot add more then 5 filters!'
          })
        }
      } else if (val == 1) {
        this.portlevels.splice(index, 1)
      } else {
        if (insightInfo.length != 0) {
          if (insightInfo.prior_op.length != 0) {
            this.portlevels = JSON.parse(JSON.stringify(insightInfo.slice(0)));
          } else {
            this.portlevels.push({
              filter_key: null,
              filter_vals: [],
              filter_ops: []
            });
          }
        } else {
          this.portlevels.push({
            filter_key: null,
            filter_vals: [],
            filter_ops: []
          });
        }
      }
    },
    loadPortVals(fltrname, pos) {
      this.isInsightloaded = false
      this.axios.post(this.uriApiUrl + 'DataAnalysis/getportfilter?asg_id=' + this.asgId, {
        filtername: fltrname.dbname
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error") {
              let wholeFilter = response.data
              this.portlevels[pos].filter_ops = wholeFilter
            } else {
              this.$notify({
                type: "error",
                text: 'Sorry! Something went Wrong! Please try again after few minutes'
              })
            }
          }
          this.isInsightloaded = true
        }).catch((error) => {
          this.isInsightloaded = true
          this.$notify({
            type: "error",
            text: "Sorry! Something went Wrong! Please try again after few minutes"
          })
        })
    },
    drawIncVsCompDD(incomingdata) {
      chartDomIvC = document.getElementById('IncResChartDD');
      if(chartDomIvC == null) return;
      chartDomIvC.style.height = "350px"
      chartDomIvC.style.width = (document.getElementById('keyDeepIncomResol').clientWidth - 100) + "px";
      this.isLoadWordInco = false
      myChartIvC = echarts.init(chartDomIvC);
      let optionIvC = {
        tooltip: {
          confine: true,
          trigger: 'axis',
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: "#777"
          }
        },
        grid: {
          left: 0,
          top: 50,
          right: '3%',
          bottom: 20,
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: incomingdata.Labels,
          splitArea: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLine: {
            show: true
          },
          axisLabel: {
            fontSize: 10,
            color: "#777"
          },
        }],
        yAxis: [{
          type: 'value',
          name: '# Tickets',
          nameTextStyle: {
            fontSize: 10,
            color: "#777"
          },
          splitArea: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLine: {
            show: true
          },
          axisLabel: {
            fontSize: 10,
            color: "#777"
          },
        },
        {
          type: 'value',
          name: 'Resolution Rate',
          nameTextStyle: {
            fontSize: 10,
            color: "#777"
          },
          splitArea: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLine: {
            show: true
          },
          axisLabel: {
            fontSize: 10,
            color: "#777"
          },
        }
        ],
        series: [{
          name: 'New',
          type: 'bar',
          data: incomingdata.Incbar,
          itemStyle: {
            borderRadius: 2,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(30,120,149,1.0)'
            },
            {
              offset: 1,
              color: 'rgba(30,120,149,0.4)'
            }
            ]),
            borderColor: '#1e7895',
            borderWidth: 1,
            opacity: 1
          }
        },
        {
          name: 'Backlog',
          type: 'bar',
          data: incomingdata.backlogbar,
          itemStyle: {
            borderRadius: 2,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(233,55,55,1.0)'
            },
            {
              offset: 1,
              color: 'rgba(233,55,55,0.4)'
            }
            ]),
            borderColor: '#bf444c',
            borderWidth: 1,
            opacity: 1
          },
        },
        {
          name: 'Resolved',
          type: 'bar',
          data: incomingdata.linetrend,
          itemStyle: {
            borderRadius: 2,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(0,99,0,1.0)'
            },
            {
              offset: 1,
              color: 'rgba(0,99,0,0.4)'
            }
            ]),
            borderColor: '#006300',
            borderWidth: 1,
            opacity: 1
          }
        },
        {
          name: 'Resolution Rate',
          type: 'line',
          symbolSize: 8,
          symbol: 'circle',
          yAxisIndex: 1,
          itemStyle: {
            color: "#009000"
          },
          tooltip: {
            confine: true,
            valueFormatter: function (value) {
              return value + ' %';
            }
          },
          data: incomingdata.compperc
        }
        ]
      };
      myChartIvC.setOption(optionIvC, {
        notMerge: true
      });
      setTimeout(() => {
        this.isLoadWordInco = true
      }, 2000);
    },
    getDrillInsights(sendIns, cond) {
      this.isDIns = false
      this.axios.post(this.uriApiUrl + 'DataAnalysis/deep_kinsight?Cond=' + cond + "&asg_id=" + this.asgId,
        sendIns,{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Nodata" && response.data != "Error" && response.data != [
              "Error"
            ]) {
              this.isCreateView = true;
              var wholeKdrive = response.data
              this.drill_Ins = wholeKdrive.ins_lis
              this.drill_Ins_dd = wholeKdrive.ins_lis_dd
              var tArr = []
              if (sendIns.getKdrill != "") {
                tArr = sendIns.getKdrill.split("~")
              }
              var tArr1 = sendIns.get_wc_col.split("~")
              if (tArr1.length > 1) {
                if (tArr1[1] == "hour") {
                  this.isCreateView = false;
                  var dayArr = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday",
                    "Saturday", "Sunday"
                  ];
                  var timeArr = ["12am-1am", "1am-2am", "2am-3am", "3am-4am", "4am-5am",
                    "5am-6am", "6am-7am", "7am-8am", "8am-9am", "9am-10am", "10am-11am",
                    "11am-12pm", "12pm-1pm", "1pm-2pm", "2pm-3pm", "3pm-4pm", "4pm-5pm",
                    "5pm-6pm", "6pm-7pm", "7pm-8pm", "8pm-9pm", "9pm-10pm", "10pm-11pm",
                    "11pm-12am"
                  ]
                  if (tArr[0] == "null") {
                    this.colVal = "Tickets created at " + tArr[1] + "(across all days)"
                  } else if (tArr[1] == "null") {
                    this.colVal = "Tickets created on "
                    switch (tArr[0]) {
                      case "Mon":
                        this.colVal += "Monday"
                        break
                      case "Tue":
                        this.colVal += "Tuesday"
                        break
                      case "Wed":
                        this.colVal += "Wednesday"
                        break
                      case "Thu":
                        this.colVal += "Thursday"
                        break
                      case "Fri":
                        this.colVal += "Friday"
                        break
                      case "Sat":
                        this.colVal += "Saturday"
                        break
                      case "Sun":
                        this.colVal += "Sunday"
                        break
                      default:
                        break
                    }
                  } else {
                    this.isShowHourlyHM = false;
                    this.colVal = "Tickets created on " + dayArr[tArr[0] - 1] +
                      " between " + timeArr[tArr[1] - 1]
                  }
                  this.nexVal = ""
                  this.inscol = "Created Date"
                } else if (tArr1[1] == "month") {
                  this.isCreateView = false;
                  var ddd = parseInt(sendIns.getKdrill) * 1000
                  var dddd = new Date(ddd)
                  this.colVal = dddd.toDateString()
                  this.nexVal = ""
                  this.inscol = "Created Date"
                  this.isShowTrend = false
                } else if (tArr1[1] == "bucket") {
                  this.isCreateView = false;
                  this.colVal = "Tickets with " + tArr1[0] + " as \"" + tArr[0] + "\" and " +
                    tArr1[1] + " as \"" + tArr[1] + "\""
                }else if(this.$parent.tabName == 'Portfolio View') {
                  this.colVal = "Tickets with " + sendIns.headerShow.split('~')[0] + " as \"" + tArr[0] + "\" and " +
                  sendIns.headerShow.split('~')[1] + " as \"" + tArr[1] + "\""
                } else {
                  this.colVal = "Tickets with " + tArr1[0] + " as \"" + tArr[0] + "\" and " +
                    tArr1[1] + " as \"" + tArr[1] + "\""
                }
              } else if (tArr.length > 1) {
                switch (sendIns.get_wc_col) {
                  case "Aging":
                    this.isCreateView = false;
                    this.colVal = "Ticket age \"" + tArr[1] + "\" for priority " + tArr[
                      0]
                    break
                  case "InVsCom":
                    this.isCreateView = false;
                    this.colVal = tArr[0] + " tickets in the month of " + tArr[1]
                    this.isShowTrend = false
                    break
                  case "Reopened":
                    this.colVal = "Reopened tickets with " + tArr[0] +
                      " priority in the month of " + tArr[1]
                    this.isShowTrend = false
                    this.isCreateView = false;
                    break
                  case "Reassigned":
                    this.colVal = "Reassigned tickets with " + tArr[0] +
                      " priority in the month of " + tArr[1]
                    this.isShowTrend = false
                    this.isCreateView = false;
                    break
                  case "SLA":
                    var tempArr2 = sendIns.splcond.split("~")
                    this.colVal = "Tickets " + tArr[0] + " (" + tempArr2[0] +
                      ") in the month of " + tArr[1]
                    this.isShowTrend = false
                    this.isCreateView = false;
                    break
                  default:
                    break
                }
              } else if (sendIns.get_wc_col == "Response") {
                this.colVal = "Responded Tickets with Priority as \"" + sendIns.getKdrill +
                  "\"";
                this.isCreateView = false;
              } else if (sendIns.get_wc_col == "Resolution") {
                this.colVal = "Resolved Tickets with Priority as \"" + sendIns.getKdrill + "\"";
                this.isCreateView = false;
              } else if (sendIns.get_wc_col == "Hop") {
                this.inscol = "Reassignment Count"
                this.colVal = "Tickets reassigned " + sendIns.getKdrill + " times"
                this.isCreateView = false;
              } else if (sendIns.get_wc_col == "Reopen") {
                this.inscol = "Reopen Count"
                this.colVal = "Tickets reopened " + sendIns.getKdrill + " times";
                this.isCreateView = false;
              } else if (sendIns.getKdrill1 == undefined) {
                let tempff = sendIns.getKdrill.split('^')
                if (tempff.length > 1) {
                  this.colVal = "Tickets with " + tempff[0] + " as \"" + tempff[1] + "\""
                  this.isCreateView = false;
                } else {
                  this.colVal = "Tickets with " + wholeKdrive.colname + " as \"" + sendIns
                    .getKdrill + "\""
                }
              } else if (sendIns.getKdrill1 == "(Blanks)") {
                this.colVal = "Tickets with " + wholeKdrive.colname + " as \"" + sendIns
                  .getKdrill1 + "\""
              } else {
                this.colVal = "Tickets with " + sendIns.getKdrill2.split("~")[0] + " as \"" +
                  sendIns.getKdrill1 + "\" and " + sendIns.getKdrill2.split("~")[1] +
                  " as \"" + sendIns.getKdrill + "\""
              }
              this.isDIns = true
            } else if (response.data == "Nodata") {
              this.isDIns = false
            } else if (response.data == "Error") {
              this.kinsightError = true
            } else {
              this.isDIns = false
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in Top Insights Drilldown. Try after sometime!'
              })
            }
            this.KDDloader = true
          }
        }).catch((response) => {
          this.isDIns = false
          this.KDDloader = true
          this.wordinsight = []
          if (this.enabledDebug == 1) {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in Top Insights Drilldown. Try after sometime!'
            })
          }
        })
    },
    getDrillWgts(sendIns, cond) {
      this.KDDchartload = false;
      this.isChartAPIError = false;
      this.isLoadWordInco = false
      this.isLoadWordMTTR = false
      this.isLoadWord = false
      this.KDDchartloadHH = false
      this.KDDchartloadDH = false
      this.axios.post(this.uriApiUrl + 'DataAnalysis/deep_kwgts?Cond=' + cond + "&asg_id=" + this.asgId,
        sendIns,{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata") {
              var wholeWgtdata = response.data
              this.ins_mttr = wholeWgtdata.ins_mttr
              if (this.ins_mttr.length != 0 && this.ins_mttr[0].slaadherence == '-') {
                this.mttrcolsDefs = [{
                  headerName: "Priority",
                  field: "Request_Priority",
                  sortable: true,
                  cellClass: 'text-start col-4',
                  resizable: true,
                  flex: 2
                },
                {
                  headerName: "MTTR",
                  field: "Mttr",
                  sortable: true,
                  valueGetter: this.daysGetter,
                  cellClass: 'text-end col-3',
                  resizable: true,
                  flex: 2
                },
                {
                  headerName: "Tickets",
                  field: "PriorityCount",
                  sortable: true,
                  cellClass: 'text-end col-3',
                  resizable: true,
                  flex: 1
                }
                ]
              } else {
                this.mttrcolsDefs = [{
                  headerName: "Priority",
                  field: "Request_Priority",
                  sortable: true,
                  cellClass: 'text-start col-4',
                  resizable: true,
                  flex: 2
                },
                {
                  headerName: "SLA Adherence",
                  field: "slaadherence",
                  sortable: true,
                  valueGetter: this.percGetter,
                  cellClass: 'text-end col-2',
                  resizable: true,
                  flex: 1
                },
                {
                  headerName: "MTTR",
                  field: "Mttr",
                  sortable: true,
                  valueGetter: this.daysGetter,
                  cellClass: 'text-end col-3',
                  resizable: true,
                  flex: 1
                },
                {
                  headerName: "Tickets",
                  field: "PriorityCount",
                  sortable: true,
                  cellClass: 'text-end col-3',
                  resizable: true,
                  flex: 1
                },
                ]
              }
              this.hourlywholedata = wholeWgtdata.gethourheat
              this.dailywholedata = wholeWgtdata.getdayheat
              if (this.isShowHourlyHM) {
                this.drawHourlyTrend();
              }
              if (this.isShowDailyHM) {
                this.drawDailyTrend();
              }
              this.mttrApi.setRowData(this.ins_mttr)
              if (wholeWgtdata.getInc_res != "Error") {
                var incomingdata = wholeWgtdata.getInc_res.Inctrend
                this.drawIncVsCompDD(incomingdata)
              }
              if (wholeWgtdata.getWC != "Error") {
                this.drop1 = wholeWgtdata.getWC.col_name
                this.wordchart = JSON.parse(JSON.stringify(wholeWgtdata.getWC.word_json.slice(
                  0)))
                this.wordchartBlank = JSON.parse(JSON.stringify(wholeWgtdata.getWC.word_json
                  .slice(0)))
                for (let i = 0; i < this.wordchartBlank.length; i++) {
                  let element = this.wordchartBlank[i]
                  if (element.text == "(Blanks)") {
                    this.wordchartBlank.splice(i, 1)
                    i--
                  }
                }
                setTimeout(() => {
                  this.drawCloudDD()
                }, 5)
              }
              this.isDIns = true;
            } else if (response.data == "Nodata") {
              this.isDIns = false
              this.noDataWgt = true
            } else {
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in Top Insights Drilldown. Try after sometime!'
              })
              this.isChartAPIError = true;
              this.isLoadWordInco = true;
              this.isLoadWordMTTR = true;
              this.isLoadWord = true;
              this.KDDchartloadHH = true;
              this.KDDchartloadDH = true;
            }
            this.KDDchartload = true
          }
        }).catch((response) => {
          this.KDDchartload = false
          this.isChartAPIError = true
          this.isLoadWordInco = true
          this.isLoadWordMTTR = true
          this.isLoadWord = true
          this.KDDchartloadHH = true
          this.KDDchartloadDH = true
          if (this.enabledDebug == 1) {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in Top Insights Drilldown. Try after sometime!'
            })
          }
        })
    },
    closeKDeepMod() {
      if (typeof URLSearchParams !== 'undefined') {
        const urlParams = new URLSearchParams(location.hash);
        const myParam = urlParams.get('id');
      }
      this.modal.hide()
      this.$emit("closeKDeep")
    },
    onReMttr(params) {
      this.mttrApi = params.api
      this.gridColumnApi = params.columnApi
      this.mttrApi.setRowData(this.ins_mttr)
      setTimeout(() => {
        this.isLoadWordMTTR = true;
        this.mttrApi.sizeColumnsToFit();
      }, 2000);
    },
    showQModal() {
      this.modal.show()
    },
    closeQModal() {
      this.modal.hide()
    },
    downloadDom(val) {
      let widgetID, imgname, geticondiv;
      switch (val) {
        case 1:
          widgetID = "crt1";
          imgname = "Incoming-Vs-Resolved.png";
          geticondiv = document.querySelectorAll('#crt1 .insideL,#crt1 .insideR, .hide-on-presentation')
          geticondiv.forEach(box => {
            box.style.opacity = 0;
          });
          document.getElementById(widgetID).classList.remove("myZoomClass")
          domtoimage.toBlob(document.getElementById(widgetID))
            .then(function (blob) {
              window.saveAs(blob, imgname);
              geticondiv.forEach(box => {
                box.style.opacity = 1;
              });
              document.getElementById(widgetID).classList.add("myZoomClass")
            });
          break;
        case 2:
          widgetID = "crt2";
          imgname = "MTTR.png";
          geticondiv = document.querySelectorAll('#crt2 .insideL,#crt2 .insideR')
          geticondiv.forEach(box => {
            box.style.opacity = 0;
          });
          document.getElementById(widgetID).classList.remove("myZoomClass")
          domtoimage.toBlob(document.getElementById(widgetID))
            .then(function (blob) {
              window.saveAs(blob, imgname);
              geticondiv = document.querySelectorAll('#crt2 .insideL,#crt2 .insideR')
              geticondiv.forEach(box => {
                box.style.opacity = 1;
              });
              document.getElementById(widgetID).classList.add("myZoomClass")
            });
          break;
        case 3:
          widgetID = "crt3";
          imgname = "WordCloud_Chart.png";
          geticondiv = document.querySelectorAll('#crt3 .insideL,#crt3 .insideR')
          geticondiv.forEach(box => {
            box.style.opacity = 0;
          });
          document.getElementById(widgetID).classList.remove("myZoomClass")
          domtoimage.toBlob(document.getElementById(widgetID))
            .then(function (blob) {
              window.saveAs(blob, imgname);
              geticondiv = document.querySelectorAll('#crt3 .insideL,#crt3 .insideR')
              geticondiv.forEach(box => {
                box.style.opacity = 1;
              });
              document.getElementById(widgetID).classList.add("myZoomClass")
            });
          break;
        case 4:
          widgetID = "crt4";
          imgname = "Hour_of_Week_Heatmap.png";
          geticondiv = document.querySelectorAll('#crt4 .insideL,#crt4 .insideR')
          geticondiv.forEach(box => {
            box.style.opacity = 0;
          });
          document.getElementById(widgetID).classList.remove("myZoomClass")
          domtoimage.toBlob(document.getElementById(widgetID))
            .then(function (blob) {
              window.saveAs(blob, imgname);
              geticondiv = document.querySelectorAll('#crt4 .insideL,#crt4 .insideR')
              geticondiv.forEach(box => {
                box.style.opacity = 1;
              });
              document.getElementById(widgetID).classList.add("myZoomClass")
            });
          break;
        case 5:
          widgetID = "crt5";
          imgname = "Day_of_Month_Heatmap.png";
          geticondiv = document.querySelectorAll('#crt5 .insideL,#crt5 .insideR')
          geticondiv.forEach(box => {
            box.style.opacity = 0;
          });
          document.getElementById(widgetID).classList.remove("myZoomClass")
          domtoimage.toBlob(document.getElementById(widgetID))
            .then(function (blob) {
              window.saveAs(blob, imgname);
              geticondiv = document.querySelectorAll('#crt5 .insideL,#crt5 .insideR')
              geticondiv.forEach(box => {
                box.style.opacity = 1;
              });
              document.getElementById(widgetID).classList.add("myZoomClass")
            });
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.modal = new Modal(document.getElementById('keyDeepmodal'))
    this.getKeyInfo.selectedWCColShow = this.$parent.catop.name + "~" + this.$parent
            .splitop.name;
    if (this.WCFilteron != undefined) {
      let chkFilterOn = this.WCFilteron.find(element => element.ticked == true)
      var selcol = chkFilterOn
      this.wcFilterOp = selcol
    }
    if (this.getKeyInfo.sendins_Dcol != "" && this.getKeyInfo.sendins.split('(Blank').length > 1 && this.getKeyInfo.sendins.split('(')[1] != 'Blanks)') {
      sendIns = {
        "getKdrill": this.getKeyInfo.sendins_Dcol + "~" + this.getKeyInfo.sendins.split('(')[0],
        "getKdrill1": this.getKeyInfo.sendins_Dcol,
        "getKdrill2": this.$parent.AnalysisOp.name + "~" + this.$parent.ins_priorLv2op.name,
        "get_wc_col": this.$parent.AnalysisOp.dbname + "~" + this.$parent.ins_priorLv2op.dbname,
        "splcond": this.getKeyInfo.splcond,
        "selid": this.getPins.selid,
        "edited": this.getPins.edited,
        "newCol": ""
      }
      this.getDrillInsights(sendIns, this.getKeyInfo.kDrillcond)
      this.getDrillWgts(sendIns, this.getKeyInfo.kDrillcond)
      this.AnalysisOns = this.$parent.AnalysisOns;
    } else {
      let newCol = ""
      let selectedWCCol = ""
      if (this.getKeyInfo.selectedWCCol == "") {
        if (this.getKeyInfo.sendins.split('~').length == 1) {
          this.getKeyInfo.selectedWCCol = this.$parent.AnalysisOp.dbname;
        } else {
          this.getKeyInfo.selectedWCCol = this.$parent.AnalysisOp.dbname + "~" + this.$parent
            .ins_priorLv2op.dbname;
        }
      } else if (this.getKeyInfo.selectedWCCol == "analyseBy~bucket") {
        selectedWCCol = this.$parent.AnalysisOp.dbname + "~bucket"
      } else if (this.getKeyInfo.selectedWCCol == "priority~bucket" && this.getKeyInfo.filt_val !=
        undefined) {
        newCol = this.getKeyInfo.filt_val
      }
      if (this.getKeyInfo.sendins == '(Blanks)' && this.getKeyInfo.selectedWCCol.split('~') > 1) {
        sendIns = {
          "getKdrill": "",
          "getKdrill1": this.getKeyInfo.sendins_Dcol,
          "get_wc_col": this.getKeyInfo.selectedWCCol,
          "splcond": this.getKeyInfo.splcond,
          "selid": this.getPins.selid,
          "edited": this.getPins.edited,
          "newCol": newCol,
          "headerShow":this.getKeyInfo.selectedWCColShow
        }
      } else {
        sendIns = {
          "getKdrill": this.getKeyInfo.sendins,
          "get_wc_col": this.getKeyInfo.selectedWCCol,
          "splcond": this.getKeyInfo.splcond,
          "selid": this.getPins.selid,
          "edited": this.getPins.edited,
          "newCol": newCol,
          "headerShow":this.getKeyInfo.selectedWCColShow
        }
      }
      this.getDrillInsights(sendIns, this.getKeyInfo.kDrillcond)
      this.getDrillWgts(sendIns, this.getKeyInfo.kDrillcond)
      this.AnalysisOns = this.$parent.AnalysisOns;
    }
    window.addEventListener("resize", this.resizeReload);
  },
  unmounted() {
    window.removeEventListener("resize", this.resizeReload);
  },
  computed: {
    getgradGreen() {
      return this.$store.getters.getgradGreen
    },
    getgradRed() {
      return this.$store.getters.getgradRed
    },
    getgradCyan() {
      return this.$store.getters.getgradCyan
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.KeydmdHt {
  overflow-y: auto;
  max-height: 75vh;
}

.modalbodypanel {
  padding: 10px 0;
}

.cdmrgn {
  margin: 0;
}

.tabContflow {
  overflow-y: auto;
}

.panelbodyHt {
  height: 380px;
}

.panelbodyMgn {
  margin: -20px 0 10px 0;
}

.chartHeightControlDD {
  height: 380px !important;
  display: block;
  position: relative;
  top: 0;
  left: 0;
}

.myDownloadDD {
  position: relative;
  top: 8px;
  right: -16px;
  text-align: center;
  border-radius: 5px;
  position: absolute;
  display: inline-flex;
}

.loading-center {
  z-index: 102;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.content-panel1 {
  height: 450px;
}

.custom-tooltip {
  visibility: hidden;
  background-color: rgba(127, 127, 127, 0.9);
  z-index: 999;
  display: inline-block;
  position: absolute;
  color: rgb(255, 255, 255);
  padding: 8px;
  border-radius: 4px;
}

.keyDeepWordClo:hover .custom-tooltip {
  visibility: visible;
}

.tabA-content {
  font-size: 0.9rem;
}
.darkTheme .modal-content {
  color: #dddddd !important;
}
</style>